/* MARMOT: чиста логика за „Коледа за фирми“. UMD за браузър и node --test. */
(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.MarmotFirmiLogic = api;
  }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var GROUPS = ['0-2', '3-5', '6-7', '8-10', '10+'];

  function excerptEmbedUrl(value) {
    var parsed;

    if (!value) {
      return null;
    }

    try {
      parsed = new URL(String(value));
    } catch (error) {
      return null;
    }

    if (
      parsed.origin !== 'https://marmot.editera.io' ||
      parsed.username ||
      parsed.password
    ) {
      return null;
    }

    var match = parsed.pathname.match(
      /^\/r\/([a-z0-9]+(?:-[a-z0-9]+)*)(?:\/vgradi)?\/?$/i
    );

    return match
      ? 'https://marmot.editera.io/r/' + match[1] + '/vgradi'
      : null;
  }

  function isExcerptHistoryState(state) {
    return !!state && state.marmotExcerpt === true;
  }

  function count(value) {
    var number = Number(value);

    if (!Number.isFinite(number)) {
      return 0;
    }

    return Math.min(9999, Math.max(0, Math.trunc(number)));
  }

  function cents(value) {
    var number = Number(value);

    if (!Number.isFinite(number)) {
      return 0;
    }

    return Math.max(0, Math.trunc(number));
  }

  function counts(raw) {
    var source = raw || {};

    return GROUPS.reduce(function (result, key) {
      result[key] = count(source[key]);
      return result;
    }, {});
  }

  function total(raw) {
    return Object.values(counts(raw)).reduce(function (sum, number) {
      return sum + number;
    }, 0);
  }

  function configured(value, fallback) {
    if (value === undefined || value === null || value === '') {
      return fallback;
    }

    return value;
  }

  function discount(totalCount, settings) {
    var options = settings || {};
    var first = count(configured(options.threshold30, 50));
    var second = count(configured(options.threshold35, 180));

    if (totalCount >= second) {
      return count(configured(options.discount35, 35));
    }

    if (totalCount >= first) {
      return count(configured(options.discount30, 30));
    }

    return count(configured(options.discount25, 25));
  }

  function roundDiscounted(coverCents, percent) {
    var cleanCents = cents(coverCents);
    var cleanPercent = count(percent);
    return Math.floor((cleanCents * (100 - cleanPercent) + 50) / 100);
  }

  function money(cents) {
    var rounded = Math.round(Number(cents) || 0);
    return (rounded / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function calculation(rawCounts, books, settings) {
    var clean = counts(rawCounts);
    var totalCount = total(clean);
    var percent = discount(totalCount, settings);
    var lines = {};
    var gross = 0;

    GROUPS.forEach(function (key) {
      var book = (books && books[key]) || {};
      var unit = roundDiscounted(book.price || 0, percent);
      var lineTotal = unit * clean[key];

      gross += lineTotal;
      lines[key] = {
        count: clean[key],
        title: book.title || '',
        coverPrice: cents(book.price),
        unitPrice: unit,
        total: lineTotal
      };
    });

    var net = Math.round(gross * 100 / 109);

    return {
      lines: lines,
      obshto_knigi: totalCount,
      otstapka_pct: percent,
      bez_dds: net,
      dds: gross - net,
      s_dds: gross
    };
  }

  function nextThreshold(totalCount, settings) {
    var options = settings || {};
    var first = count(configured(options.threshold30, 50));
    var second = count(configured(options.threshold35, 180));

    if (totalCount < first) {
      return {
        target: first,
        remaining: first - totalCount,
        discount: count(configured(options.discount30, 30))
      };
    }

    if (totalCount < second) {
      return {
        target: second,
        remaining: second - totalCount,
        discount: count(configured(options.discount35, 35))
      };
    }

    return null;
  }

  function validateStep(step, state) {
    var data = state || {};

    if (step === 1) {
      return total(data.broyki) > 0 ? {} : {
        broyki: 'Нужно е поне едно дете, за да подберем книга.'
      };
    }

    if (step === 2 || step === 3) {
      return {};
    }

    if (step === 4) {
      var addresses = data.dostavka && data.dostavka.adresi;
      var hasAddress = (addresses || []).some(function (address) {
        return String(address).trim();
      });

      return hasAddress ? {} : {
        dostavka: 'Добавете адрес за доставка.'
      };
    }

    if (step === 5) {
      var errors = {};

      if (total(data.broyki) === 0) {
        errors.broyki = 'Нужно е поне едно дете, за да подберем книга.';
      }

      ['ime', 'rolya', 'firma', 'imeyl'].forEach(function (key) {
        if (!String(data[key] || '').trim()) {
          errors[key] = 'Задължително поле.';
        }
      });

      if (
        data.imeyl &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.imeyl)
      ) {
        errors.imeyl = 'Въведете валиден имейл.';
      }

      return errors;
    }

    return {};
  }

  function selectedBooks(result) {
    return GROUPS.reduce(function (books, key) {
      var title = result.lines[key].title;

      if (title) {
        books[key] = title;
      }

      return books;
    }, {});
  }

  function payload(state, books, settings, kind) {
    var data = state || {};
    var result = calculation(data.broyki, books, settings);

    return {
      vid: kind || 'zapitvane',
      izprateno_ot: 'sayt',
      firma: data.firma || '',
      ime: data.ime || '',
      rolya: data.rolya || '',
      imeyl: data.imeyl || '',
      telefon: data.telefon || '',
      broyki: counts(data.broyki),
      knigi: selectedBooks(result),
      tema: data.tema || null,
      kartichka: {
        iska: !!(data.kartichka && data.kartichka.iska),
        dizayn: data.kartichka && data.kartichka.dizayn || 'marmot',
        pechat: data.kartichka && data.kartichka.pechat || 'marmot',
        tekst: data.kartichka && data.kartichka.tekst || ''
      },
      dostavka: {
        vid: data.dostavka && data.dostavka.vid || 'edin',
        adresi: data.dostavka && data.dostavka.adresi || [],
        data: data.dostavka && data.dostavka.data || null
      },
      smetka: {
        obshto_knigi: result.obshto_knigi,
        otstapka_pct: result.otstapka_pct,
        bez_dds: result.bez_dds,
        dds: result.dds,
        s_dds: result.s_dds
      },
      otkas: data.otkas !== false,
      belezhka: data.belezhka || '',
      reklamna_broyka: data.reklamna_broyka || undefined
    };
  }

  function readable(value) {
    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value === 'string') {
      return value;
    }

    return JSON.stringify(value);
  }

  function fallbackLead(failure) {
    var reason = failure || {};

    if (reason.type === 'timeout') {
      return 'Editera не отговори за 8 секунди – запитването може да е ' +
        'стигнало и там; провери за дубликат.';
    }

    if (reason.type === 'http') {
      return 'Editera върна грешка (код ' + cents(reason.status) + ').';
    }

    if (reason.type === 'network') {
      return 'Editera не беше достъпна (мрежова грешка).';
    }

    if (reason.type === 'none') {
      return 'Адресът на Editera не е настроен.';
    }

    return '';
  }

  function groupLabel(group) {
    return group.replace('-', '–') + ' г.';
  }

  function groupLines(source) {
    var groupCounts = counts(source.broyki);
    var groupBooks = source.knigi || {};

    return GROUPS.map(function (group) {
      var line = groupLabel(group) + ': ' + groupCounts[group] + ' деца';

      if (groupBooks[group]) {
        line += ' – ' + groupBooks[group];
      }

      return line;
    });
  }

  function fallbackText(data, failure) {
    var source = data || {};

    var lines = [
      fallbackLead(failure),
      'Дошло по резервния път от страницата „Коледа за фирми“.',
      '',
      'Вид: ' + (source.vid || ''),
      'Фирма: ' + (source.firma || ''),
      'Име: ' + (source.ime || ''),
      'Роля: ' + (source.rolya || ''),
      'Имейл: ' + (source.imeyl || ''),
      'Телефон: ' + (source.telefon || ''),
      'Бройки и книги:'
    ].concat(groupLines(source), [
      'Тема: ' + readable(source.tema),
      'Картичка: ' + readable(source.kartichka),
      'Доставка: ' + readable(source.dostavka),
      'Сметка: ' + readable(source.smetka),
      'Откъси: ' + readable(source.otkas),
      'Бележка: ' + (source.belezhka || ''),
      'Рекламна бройка: ' + readable(source.reklamna_broyka),
      '',
      'JSON:',
      JSON.stringify(source, null, 2)
    ]);

    return lines.filter(function (line, index) {
      return line || index > 1;
    }).join('\n');
  }

  function isFallbackSuccess(url, ok) {
    if (!ok || !url) {
      return false;
    }

    try {
      var parsed = new URL(url, 'https://marmot-books.com');
      return parsed.searchParams.get('contact_posted') === 'true';
    } catch (error) {
      return false;
    }
  }

  return {
    GROUPS: GROUPS,
    excerptEmbedUrl: excerptEmbedUrl,
    isExcerptHistoryState: isExcerptHistoryState,
    count: count,
    cents: cents,
    counts: counts,
    total: total,
    discount: discount,
    roundDiscounted: roundDiscounted,
    money: money,
    calculation: calculation,
    nextThreshold: nextThreshold,
    validateStep: validateStep,
    payload: payload,
    fallbackText: fallbackText,
    isFallbackSuccess: isFallbackSuccess
  };
}));
